module.exports = __webpack_public_path__ + "img/delete-icon.60140c01.svg";